export default __webpack_public_path__ + "996c2fb83e756700e398ede07d1fd634.svg";